import React from "react"

/* eslint-disable */ 
interface DeleteProps {
  onClick?: () => {} | void;
}
function DeleteIcon(prop: DeleteProps) {
  const { onClick } = prop;
  return (
    <span onClick={onClick} className="anticon anticon-delete">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 16 16"
      >
        <path
          d="M13 6.81323V12.6666C13 13.9999 12.6667 14.6666 11 14.6666H5C3.33333 14.6666 3 13.9999 3 12.6666V6.81323"
          stroke="currentcolor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.33301 1.3335H12.6663C13.9997 1.3335 14.6663 2.00016 14.6663 3.3335V4.66683C14.6663 6.00016 13.9997 6.66683 12.6663 6.66683H3.33301C1.99967 6.66683 1.33301 6.00016 1.33301 4.66683V3.3335C1.33301 2.00016 1.99967 1.3335 3.33301 1.3335Z"
          stroke="currentcolor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}

export default DeleteIcon;
